import { LOAD_MORE_SET_PRODUCTS } from '../Actions/LoadMore.action';
import { SET_TOTAL_PRODUCTS_COUNT} from '../Actions/LoadMore.action';

const DEFAULT_STATE = {
    currentProductCount: 0,
    totalProducts: 0
}

export const loadMore = (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case LOAD_MORE_SET_PRODUCTS:
        case SET_TOTAL_PRODUCTS_COUNT:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
}